import React from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ_ITEMS: FAQItem[] = [
  {
    question: "What is the Icy Veins App?",
    answer:
      "The Icy Veins app is a companion desktop app that gives you everything you love about Icy Veins without needing to open your browser. It covers Retail World of Warcraft with support for Classic and future game modes on the way.",
  },
  {
    question: "What features does the Icy Veins app have?",
    answer:
      "With the launch of the Icy Veins app, you can get the NEW Class Codex addon, along with all Icy Veins class and spec guides.",
  },
  {
    question: "What is the Class Codex Addon?",
    answer:
      "Class Codex is a new feature exclusive to the Icy Veins app. It's a World of Warcraft addon that brings the Icy Veins World of Warcraft Talents, Best in Slot Gear, Rotations, Stats and more directly into the game. No more alt-tabbing.",
  },
  {
    question: "Is the Icy Veins app safe to use?",
    answer:
      "The Icy Veins app is completely safe and compliant with Blizzard's Terms of Service. You will not get banned or penalized for using the app.",
  },
  {
    question: "Is the Icy Veins app free?",
    answer:
      "Yes, the Icy Veins app is completely free to use. The Icy Veins app is monetized with ads. Ad-free will be available for Icy Veins premium subscribers shortly.",
  },
];

export function WoWAppFAQ() {
  return (
    <div>
      <h2 className="m-0 mb-[36px] flex items-center gap-[12px] text-[14px] font-bold leading-[20px] text-white">
        <span className="h-[20px] w-[2px] shrink-0 rounded-[2px] bg-accent-blue-400" />
        Frequently Asked Questions
      </h2>
      <dl className="m-0 flex flex-col gap-[48px]">
        {FAQ_ITEMS.map((item) => (
          <div key={item.question}>
            <dt className="text-[18px] font-bold leading-[32px] text-white">{item.question}</dt>
            <dd className="m-0 mt-[8px] text-[18px] font-normal leading-[32px] text-lavender-50">{item.answer}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default WoWAppFAQ;
